import * as React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Layout from "../Pages/Layout";
import Login from "../Pages/Login";
import ResetPassword from "../Pages/ResetPassword";
import EditAccount from "../Pages/EditAccount";
import ForgetPassword from "../Pages/ForgetPassword";
import EditedPassword from "../Pages/EditedPassword";
import AddClaim from "../Pages/AddClaim";
import Error404 from "../Pages/Error404";
import MonthsRent from "../Pages/MonthsRent";
import UnpaidRent from "../Pages/UnpaidRent";
import Dashboard from "../Pages/Dashboard";

import { useConnectedUser } from "../Context/ConnectedUserContext";

import GlobalCituation from "../Pages/GlobalCituation";
import LivingContracts from "../Pages/LivingContracts";
import Outstandings from "../Pages/Outstandings";
import ChangeInsurance from "../Pages/ChangeInsurance";
import InsuranceRequest from "../Pages/InsuranceRequest";
import CommitementPdf from "../Pages/CommitementPdf";
import ListClaim from "../Pages/ListClaim";
import ListLeaveTerritory from "../Pages/ListLeaveTerritory";
import AddRequestLeaveTerritory from "../Pages/AddRequestLeaveTerritory/AddRequestLeaveTerritory";
import ListReleaseRequests from "../Pages/ListReleaseRequests";
import AddReleaseRequests from "../Pages/AddReleaseRequests/AddReleaseRequests";
import Contact from "../Pages/Contact";
import AddContact from "../Pages/AddContact";
import AddContactNotConnected from "../Pages/AddContactNotConnected";
import ListFinancingRequest from "../Pages/ListFinancingrequest";
import DetailsFinancingRequest from "../Pages/DetailsFinancingRequest";
// import AddFinancingRequest from "../Pages/AddFinancingRequest";
import DetailsClaim from "../Pages/DetailsClaim";
// import ListSimulations from "../Pages/ListSimulations";
import SimulateurStep1 from "../Pages/Simulateur/SimulateurStep1";
// import SimulateurStep2 from "../Pages/Simulateur/SimulateurStep2";
// import SimulateurStep3 from "../Pages/Simulateur/SimulateurStep3";

import SimulateurStep1NotConnected from "../Pages/SimulateurNotConnected/SimulateurStep1NotConnected";
import SimulateurStep2NotConnected from "../Pages/SimulateurNotConnected/SimulateurStep2NotConnected";

import FinancingRequestNotConnected from "../Pages/FinancingRequestNotConnected/FinancingRequestNotConnected";
import FinancingRequestNotConnectedStep1 from "../Pages/FinancingRequestNotConnected/FinancingRequestNotConnectedStep1";
import FinancingRequestNotConnectedStep2 from "../Pages/FinancingRequestNotConnected/FinancingRequestNotConnectedStep2";
import FinancingRequestNotConnectedStep3 from "../Pages/FinancingRequestNotConnected/FinancingRequestNotConnectedStep3";
import ConfirmRequestNotConnected from "../Pages/FinancingRequestNotConnected/ConfirmRequestNotConnected";
import FinancingRequestRecapNotConnected from "../Pages/FinancingRequestNotConnected/FinancingRequestRecapNotConnected";

import FinancingRequestStep1 from "../Pages/FinancingRequest/FinancingRequestStep1";

import FinancingRequestStep2 from "../Pages/FinancingRequest/FinancingRequestStep2";
import FinancingRequestStep3 from "../Pages/FinancingRequest/FinancingRequestStep3";
import ConfirmRequest from "../Pages/FinancingRequest/ConfirmRequest";

import DetailsFinancingRequestNotConnected from "../Pages/DetailsFinancingRequestNotConnected/DetailsFinancingRequestNotConnected";

import CookieConsent from "react-cookie-consent";

import InvoiceEditing from "../Pages/InvoiceEditing";

import "./App.scss";

const App = () => {
  const { token, isFirstTimeConnect } = useConnectedUser();

  return (
    <div className="app-attijari">
      {!token && (
        <CookieConsent
          location="none"
          enableDeclineButton
          declineButtonText="Refuser"
          buttonText="Accepter"
          cookieName="AttijariCookies"
          style={{
            background: "#fff",
            color: "#000",
            width: "60%",
            left: "20%",
            overflowY: "auto",
            height: "450px",
            overflowX: "hidden",
            display: "block",
            top: "15%",
          }}
          overlay="true"
          containerClasses="cookiesContainer"
          buttonStyle={{
            color: "#212529",
            backgroundColor: "#fab818",
            borderRadius: "40px",
            padding: "10px 24px",
          }}
          declineButtonStyle={{ borderRadius: "40px", padding: "10px 24px" }}
          expires={365}
        >
          <h2>
            Bienvenu sur DIGILEASE l’application digitale d’Attijari leasing /
            le site web de « Attijari Leasing » .
          </h2>
          <p>
            Lors de votre navigation sur notre site, nous et/ou nos partenaires
            utilisons des cookies dont certains sont strictement nécessaires au
            bon fonctionnement du site, et d'autres sont utilisés pour :
          </p>
          <ul>
            <li>
              Améliorer votre expérience utilisateur, en personnalisant vos
              fonctionnalités et en se souvenant de vos choix.
            </li>
            <li>
              Mesurer l’audience en suivant le nombre de visiteurs et en
              comprenant comment vous arrivez sur notre site
            </li>
            <li>
              Proposer des offres et services personnalisés et en suivre les
              performances.
            </li>
            <li>
              Partager des informations avec les réseaux sociaux utilisés et
              vous permettre de visualiser du contenu hébergé sur un site
              externe.
            </li>
          </ul>
          <p>
            Votre consentement à l'installation de cookies, non strictement
            nécessaires, est libre et peut être retiré ou donné à tout moment.
            Vous pouvez obtenir plus d'informations via notre{" "}
            <u>politique cookies.</u>
          </p>
          <p>
            <strong>Politique cookies</strong>
          </p>
          <p>
            L’Utilisateur est informé que, lors de ses visites sur le Site, un
            cookie peut s'installer automatiquement sur son logiciel de
            navigation et être temporairement conservé en mémoire sur son disque
            dur. Un cookie est un élément qui ne permet pas d'identifier
            l’Utilisateur mais sert à enregistrer des informations relatives à
            la navigation de celui-ci sur le Site. Ces informations sont
            utilisées aux fins d’optimisation de la sécurité du Site et de
            fournir un service optimal. Ainsi, les cookies sont utilisées pour :
          </p>
          <ul>
            <li>
              Gérer les paramètres personnels lors de la connexion de
              l’Utilisateur au Site sécurisé.
            </li>
            <li>
              Enregistrer des informations sur la navigation de l’Utilisateur
              sur le Site pour orienter sa navigation vers les contenus les
              mieux adaptés.
            </li>
            <li>Mesurer le nombre de visites sur le Site.</li>
            <li>Evaluer l’efficacité de nos campagnes de promotion interne.</li>
          </ul>
          <p>
            En aucun cas, les "Cookies" n'ont pour objet d'exploiter des
            informations personnelles nominatives concernant les personnes
            connectées au site.
          </p>
          <p>
            L’Utilisateur reconnaît avoir été informé de cette pratique et
            autorise expressément et sans opposition ni réserve, La Banque à
            l'employer.
          </p>
          <p>
            Cependant, Attijari leasing attire l'attention des Utilisateurs et
            des internautes que si les logiciels de navigation de leurs
            ordinateurs sont configurés pour refuser les "Cookies", l'accès à
            certains services peut se révéler altéré, voire impossible.
          </p>
          <p>
            <strong>Confidentialité</strong>
          </p>
          <p>
            Lorsque vous consultez notre site Web, des données peuvent être
            stockées dans votre navigateur sous forme de cookies. Un fichier
            cookie permet principalement d'améliorer votre expérience en gardant
            en mémoire certaines informations relatives à votre navigation sur
            le site
          </p>
          <p>
            Certaines familles de cookies sont soumises à votre consentement.
            Vous pouvez personnaliser vos choix au travers de cette page ou
            revenir dessus à tout moment et obtenir plus d'information via notre{" "}
            <u>politique cookies.</u>
          </p>
        </CookieConsent>
      )}

      <BrowserRouter basename={process.env.REACT_APP_BASE_PREFIX}>
        <Routes>
          <Route
            path="/login"
            element={
              token && !isFirstTimeConnect ? (
                <Navigate replace to="/" />
              ) : (
                <Login />
              )
            }
          />

          <Route
            path="/details-financing-request"
            element={
              token ? (
                <Navigate replace to="/" />
              ) : (
                <DetailsFinancingRequestNotConnected />
              )
            }
          />

          <Route
            path="/forget-password"
            element={token ? <Navigate replace to="/" /> : <ForgetPassword />}
          />
          <Route
            path="/reset-password/:token"
            element={token ? <Navigate replace to="/" /> : <ResetPassword />}
          />
          <Route
            path="/edited-password"
            element={token ? <Navigate replace to="/" /> : <EditedPassword />}
          />

          <Route
            path="/prise-de-rendez-vous"
            element={
              token ? <Navigate replace to="/" /> : <AddContactNotConnected />
            }
          />
          <Route
            path="/simulations"
            element={
              token ? (
                <Navigate replace to="/" />
              ) : (
                <SimulateurStep1NotConnected />
              )
            }
          />
          <Route
            path="/simulation-step-2"
            element={
              token ? (
                <Navigate replace to="/" />
              ) : (
                <SimulateurStep2NotConnected />
              )
            }
          />
          <Route
            path="/financing-request"
            element={
              token ? (
                <Navigate replace to="/" />
              ) : (
                <FinancingRequestNotConnected />
              )
            }
          />
          <Route
            path="/customer-information"
            element={
              token ? (
                <Navigate replace to="/" />
              ) : (
                <FinancingRequestNotConnectedStep1 />
              )
            }
          />
          <Route
            path="/documents"
            element={
              token ? (
                <Navigate replace to="/" />
              ) : (
                <FinancingRequestNotConnectedStep2 />
              )
            }
          />
          <Route
            path="/resume"
            element={
              token ? (
                <Navigate replace to="/" />
              ) : (
                <FinancingRequestNotConnectedStep3 />
              )
            }
          />
          <Route
            path="/financing-request-recap"
            element={
              token ? (
                <Navigate replace to="/" />
              ) : (
                <FinancingRequestRecapNotConnected />
              )
            }
          />
          <Route
            path="/confirm-soumission-request"
            element={
              token ? (
                <Navigate replace to="/" />
              ) : (
                <ConfirmRequestNotConnected />
              )
            }
          />

          <Route path="/not-found" element={<Error404 />} />

          <Route element={<Layout />}>
            <Route path="/edit-account/" element={<EditAccount />} />
            {!isFirstTimeConnect && (
              <>
                <Route path="/" element={<Dashboard />} />
                <Route path="/global-situation" element={<GlobalCituation />} />
                <Route
                  path="/global-situation/:contract_number?"
                  element={<MonthsRent />}
                />

                {/* <Route path="/month-rent" element={<MonthsRent />} /> */}
                <Route path="/unpaid-rent" element={<UnpaidRent />} />
                <Route path="/invoice-editing" element={<InvoiceEditing />} />
                <Route path="/living-contracts" element={<LivingContracts />} />
                <Route path="/outstandings" element={<Outstandings />} />
                <Route
                  path="/list-insurance-requests"
                  element={<ChangeInsurance />}
                />
                <Route
                  path="/list-insurance-requests/requests-change-insurance"
                  element={<InsuranceRequest />}
                />
                <Route
                  path="/list-insurance-requests/commitement-pdf/:id"
                  element={<CommitementPdf />}
                />
                <Route
                  path="/list-authorization-leave-territory"
                  element={<ListLeaveTerritory />}
                />
                <Route
                  path="/list-authorization-leave-territory/add-request-leave-territory"
                  element={<AddRequestLeaveTerritory />}
                />
                <Route
                  path="/list-financing-request"
                  element={<ListFinancingRequest />}
                />
                <Route
                  path="/list-financing-request/show-financing-request/:id"
                  element={<DetailsFinancingRequest />}
                />

                {/*<Route
                  path="/list-financing-request/add-financing-request"
                  element={<AddFinancingRequest />}
                /> */}
                <Route
                  path="/financing-request/information-applicant/:id?"
                  element={<FinancingRequestStep1 />}
                />

                <Route
                  path="/financing-request/documents-to-attach/:id?"
                  element={<FinancingRequestStep2 />}
                />
                <Route
                  path="/financing-request/recovery/:id?"
                  element={<FinancingRequestStep3 />}
                />
                <Route
                  path="/financing-request/confirm-request/:id?"
                  element={<ConfirmRequest />}
                />

                <Route
                  path="/release-requests"
                  element={<ListReleaseRequests />}
                />
                <Route
                  path="/release-requests/add-release-requests"
                  element={<AddReleaseRequests />}
                />
                {/* <Route path="/list-simulations" element={<ListSimulations />} /> */}
                <Route
                  path="/list-financing-request/simulateur-step-1/:id?"
                  element={<SimulateurStep1 />}
                />
                {/* <Route
                  path="/list-simulations/simulateur-step-2/:id?"
                  element={<SimulateurStep2 />}
                /> */}
                {/* {<Route
                  path="/list-simulations/simulateur-step-3/:id?"
                  element={<SimulateurStep3 />}
                />} */}

                <Route path="/list-claim" element={<ListClaim />} />
                <Route path="/list-claim/add-claim" element={<AddClaim />} />
                <Route
                  path="/list-claim/add-claim/:id"
                  element={<DetailsClaim />}
                />
                <Route path="/contact" element={<Contact />} />
                <Route path="/add-contact" element={<AddContact />} />
              </>
            )}
            <Route
              path="*"
              element={
                <Navigate
                  replace
                  to={isFirstTimeConnect ? `/edit-account` : "/"}
                />
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
